<template>
  <div class="row primary-filter">
    <div class="left-section col-md-auto filter-grid">
      <ul class="inlinelist">
        <li class="app-side-menu">
          <span @click="isOpen = true" class="pointer">
            <svgicon name="menu" width="20" height="20" :original="true" class="menu" />
          </span>
          <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
            <Sidebar @close="isOpen = false" />
          </div>
        </li>
        <li class="color-changes category">
          <FilterDropdown
            v-if="menuOptions.length"
            :options="menuOptions"
            :selected="selectedCategory"
            @updateOption="onChangeOption"/>
        </li>
      </ul>
    </div>
   <div class="center-section col filter-grid" :class="{ 'popup-open': showPopup }">
      <div class="row" v-if="!noSearchFilter">
        <div class="col">
          <div class="app-search-label" :class="{'has-tags': hasActiveTags}">
            <div v-if="showPopup">
              <SearchPopup
                :searchParameters="searchParameters"
                :presearchedParams="preSearchedParams"
                @closePopup="closePopup"
                @search="searchByParameter"/>
            </div>
            <div class="searchterm tagblock" v-if="!showPopup" @click="onClick"
              :class="{ 'pointer' : noParams}">
              <svgicon name="search" width="15" height="15" :original="true" />
              <input type="text" :placeholder="searchText" @keyup="search" v-model="query"
                v-if="!enableSearchPopup">
              <span type="text" class="tagblock_list" v-else>
                <span v-for="(value, name, index) in displaySearchParams" :key="index">
                  <span v-if="value && multiSearchFields.includes(name)">
                      <Tag closable @close="removeParamTag(name)">
                        <div class="searchtag-title">
                          {{ getTagByName(name) }}
                        </div>
                        <span v-if="value.length === 1">
                          {{ dataToShow(value) }}
                        </span>
                        <Tooltip
                          v-else
                          popper-class="max-width"
                          :open-delay="200"
                          effect="dark"
                          placement="bottom-start"
                        >
                          <div slot="content">{{ dataOnHover(value) }}</div>
                          <span class="pointer">{{ dataToShow(value) }}</span>
                        </Tooltip>
                      </Tag>
                    </span>
                    <span v-else-if="value">
                    <Tag closable @close="removeParamTag(name)">
                      <div class="searchtag-title">{{ getTagByName(name) }}</div>
                      {{ value }}
                    </Tag>
                  </span>
                </span>
                <span v-if="noParams" class="inputtextlabel">{{searchText}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-section col-md-auto filter-grid filter-button">
      <span>
        <ul class="filter-btn-group inlinelist">
          <li v-for="button in buttonsList" :key="button.id">
            <span v-if="button.show &&
              (!button.permission || $hasPermission(button.permission))">
              <router-link
                v-if="!button.disabled && button.routerLinkName"
                :to="{ name: button.routerLinkName, query : {ids: queryParams}}">
                <button class="btn" :class="button.class">{{button.name}}</button>
              </router-link>
              <Tooltip
                v-else-if="button.disableTooltip && button.disabled"
                effect="dark"
                placement="bottom-start">
                <div slot="content">{{button.disableTooltip}}</div>
                <span class="pointer">
                  <button
                    class="btn"
                    :class="getClass(button)"
                    :disabled="button.disabled"
                    @click="$emit(button.emitMethod)"
                  >{{button.name}}</button>
                </span>
              </Tooltip>
              <Dropdown
                v-else-if="button.dropdownList && !isUploading"
                trigger="click"
                @visible-change="toggleButton(button.id)"
                :class="{dropdownbutton : dropdownOpen && dropdownOpen[button.id]}">
                <button type="primary" class="btn btn-secondary" :class="button.class">
                  {{button.name}}
                  <svgicon
                    name="categorydropdown"
                    class="dropdown-icon"
                    width="10"
                    height="10"
                    :original="true"/>
                </button>
                <Dropdown-menu slot="dropdown" :class="button.dropdownClass">
                  <Dropdown-item v-for="(dropdownItem,index) in button.dropdownList" :key="index">
                    <span v-if="dropdownItem.type === 'upload' &&
                        (!dropdownItem.permission || $hasPermission(dropdownItem.permission))">
                      <label>
                        <input
                          class="upload-material"
                          type="file"
                          id="file"
                          :ref="dropdownItem.id ?
                            `${dropdownItem.uploadEmitMethod}_${dropdownItem.id}` :
                              dropdownItem.uploadEmitMethod"
                          :accept="`${AttachmentConstants.excelMimes}`"
                          @change="handleFileUpload(dropdownItem.uploadEmitMethod, dropdownItem.id)"/>
                        <span class="action">{{dropdownItem.name}}</span>
                      </label>
                      <a :href="`${$asset_path}static/sample/${dropdownItem.sampleFileName}`"
                        v-if="dropdownItem.sampleFileName"
                        download
                        class="format-text"
                        target="_blank">Sample format
                      </a>
                      <a href="javascript:void(0)"
                        @click="$emit(dropdownItem.sampleFileEmitMethod)"
                        v-else
                        class="format-text">Sample format</a>
                    </span>
                    <span v-if="dropdownItem.type === 'link' &&
                      hasConfiguration(dropdownItem, button.parentConfig)">
                      <label>
                        <li class="select_options">
                          <router-link
                            v-if="dropdownItem.routerLinkName"
                            :to="getRouterLink(dropdownItem)">
                            <a href="#" class="action">{{dropdownItem.name}}</a>
                          </router-link>
                        </li>
                      </label>
                    </span>
                  </Dropdown-item>
                </Dropdown-menu>
              </Dropdown>
              <Processing
                v-else-if="button.dropdownList && isUploading"
                background="#0073FF"
                size="30px"/>
              <button
                v-else-if="button.name !== 'Download'"
                class="btn"
                :class="getClass(button)"
                :disabled="button.disabled"
                @click="$emit(button.emitMethod)">{{button.name}}</button>
              <button
               v-else
               class="btn"
               :class="getClass(button)"
               :disabled="button.disabled"
               @click="getPopDialog">{{button.name}}</button>
            </span>
          </li>
        </ul>
      </span>
    </div>
    <Dialog
      width="360px"
      :center="false"
      title="Select"
      :append-to-body="true"
      :visible.sync="openDiscardAllDialog"
      class="infodialog topmargin_n centerdialogblock">
      <div class="dialog-content">
        <RadioGroup v-model= "radio" display="block" class="text-label mb-0 px-30 text-lowercase">
          <Radio :label="0">Selected Indents on this page only</Radio>
          <Radio :label="1" class="ml-0">All Indents on this filter combinations</Radio>
        </RadioGroup>
      </div>
      <span slot="footer" class="dialog-footer">
        <Button type="secondary" size="mini" @click="openDiscardAllDialog = false">CANCEL</Button>
        <Button type="primary" size="mini" @click="$emit('downloadExcel', radio) , openDiscardAllDialog = false">DOWNLOAD</Button>
      </span>
    </Dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FilterDropdown from '@common/components/FilterDropdown';
import SearchPopup from '@common/components/SearchPopup';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import debounce from 'debounce';
import Sidebar from '@/modules/common/Sidebar';
import Vue from 'vue';

export default {
  props: {
    searchText: { type: String },
    menuOptions: { type: Array },
    selectedCategory: { type: Object },
    queryParams: { type: String },
    buttonsList: { type: Array },
    noSearchFilter: { type: Boolean },
    isUploading: { type: Boolean },
    enableSearchPopup: { type: Boolean },
    searchParameters: { type: Array },
    preSearchedParams: { type: Object },
  },
  components: {
    Sidebar,
    FilterDropdown,
    SearchPopup,
  },
  data() {
    return {
      query: null,
      isOpen: false,
      focusSearch: true,
      dropdownOpen: null,
      AttachmentConstants,
      showPopup: false,
      searchedParams: {},
      displaySearchParams: {},
      multiSearchFields: ['source', 'destination', 'sourceRefIds', 'destinationRefIds', 'sourceNames', 'destinationNames'],
      openDiscardAllDialog: false,
      radio: 0,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
    }),
    noParams() {
      return Object.values(this.searchedParams).every(parameter => !parameter);
    },
    hasActiveTags() {
      return Object.values(this.displaySearchParams).some(param => param);
    },
  },
  created() {
    if (this.preSearchedParams) {
      this.searchParameters.map((searchParameter) => {
        Vue.set(
          this.searchedParams,
          searchParameter.query,
          this.preSearchedParams[searchParameter.query],
        );
      });
      this.displaySearchParams = { ...this.searchedParams };
    }
    if (this.$hasFeature('shipment_number_search_in_ready_for_billing') && this.$hasFeature('ready_for_billing') && this.selectedCategory.name === 'Ready for Billing') {
      const isShipmentNumberFieldAlreadyPresent = this.searchParameters.some(item => (item.id === 5 && item.query === 'shipment_number'));
      if (!isShipmentNumberFieldAlreadyPresent) {
        this.searchParameters.push({
          id: 5,
          name: 'Shipment number',
          query: 'shipment_number',
          tname: 'INVOICE_SEARCH_SHIPMENT_NO',
        });
      }
    }
    this.loadSearchFromSession();
    this.setDropDownOpenConstants();
  },
  methods: {
    loadSearchFromSession() {
      if (!this.enableSearchPopup) {
        const sessionQuery = localStorage.getItem(`${this.$route.name}-search-query`);
        if (sessionQuery) { this.query = sessionQuery; this.search(); }
      }
    },
    setSearchToSession() {
      if (!this.enableSearchPopup) {
        localStorage.setItem(`${this.$route.name}-search-query`, this.query || '');
      }
    },
    toggleButton(id) {
      const obj = {};
      obj[id] = !this.dropdownOpen[id];
      this.dropdownOpen = Object.assign({}, this.dropdownOpen, obj);
    },
    setDropDownOpenConstants() {
      this.dropdownOpen = {};
      this.buttonsList.forEach((val) => {
        if (val.dropdownList) {
          this.dropdownOpen[val.id] = false;
        }
      });
    },
    hasConfiguration(value, parentConfig) {
      let configForUser = this.configurations;
      if (parentConfig) {
        configForUser =
          this.configurations && this.configurations[parentConfig];
      }
      return configForUser && configForUser[value.config];
    },
    getRouterLink(value) {
      let routerLink = { name: value.routerLinkName };
      if (value.queryParams) {
        routerLink = Object.assign(routerLink, { query: value.queryParams });
      }
      return routerLink;
    },
    getPopDialog() {
      this.openDiscardAllDialog = true;
    },
    unCheck(value) {
      this[value] = null;
    },
    getTagByName(name) {
      let tagConstant = this.searchParameters.find((param) => {
        if (param.multiDropDownQueryOptions) {
          return param.multiDropDownQueryOptions.find(
            val => val.query === name,
          );
        }
        return param.query === name;
      });
      if (tagConstant && tagConstant.multiDropDownQueryOptions) {
        tagConstant = tagConstant.multiDropDownQueryOptions.find(
          val => val.query === name,
        );
      }
      const tagName = tagConstant && tagConstant.name;
      const tagTranslateName = tagConstant && tagConstant.tname;
      return tagTranslateName ? this.$t(tagTranslateName) : tagName;
    },
    removeParamTag(tag) {
      this.unCheck(tag);
      this.searchedParams[tag] = null;
      this.displaySearchParams[tag] = null;
      this.searchByParameter(this.searchedParams);
    },
    searchByParameter(query, isReset = false) {
      const queryCleaned = Object.fromEntries(Object.entries(query).filter(([key, value]) => value !== ''));
      // used to display the searched queries when the pop up is reopened
      this.searchedParams = queryCleaned;
      this.displaySearchParams = queryCleaned;
      this.$emit('searchByParameter', queryCleaned);
      if (!isReset) {
        this.closePopup();
      }
    },
    onClick() {
      this.focusSearch = false;
      if (this.enableSearchPopup) {
        this.showPopup = true;
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    search: debounce(function debounceSearch() {
      this.setSearchToSession();
      this.$emit('search', this.query);
    }, 500),
    onChangeOption(data) {
      if (this.$router.history.current.name === 'OrdersList') {
        this.$emit('changeCategory', data);
      } else {
        this.$router.push({ name: data.id });
      }
    },
    getClass(button) {
      let className = button.class;
      if (button.disabled) {
        className = className.concat(' disablebtn ');
      }
      return className;
    },
    handleFileUpload(emitMethod, id = null) {
      const refName = id ? `${emitMethod}_${id}` : emitMethod;
      this.file = this.$refs[refName][0].files[0];
      this.$emit(emitMethod, this.file, id);
      // Reset the uploaded file value
      const input = this.$refs[refName][0];
      input.type = 'file';
    },
  },
};
</script>
<style lang="scss">
@import "~@common/styles-transporter/settings";
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';
.primary-filter {
  border: 1px solid #E9F1F5;
  background-color: #fff;
  height: 50px;
  font-family:$fontSemibold;
  .left-section {
    flex: 0 0 auto;
  }
  .center-section {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    border-right: 1px solid #E9F1F5;
    padding-right: 10px;
    &.popup-open {
      overflow: visible;
    }
    .app-search-label.has-tags{
      overflow-x: auto;
      padding: 13px 0 4px 15px;
      &::-webkit-scrollbar {
        height: 3px;
      }
    }
    .tagblock_list {
      display: block;
      white-space: nowrap;
      overflow-x: visible;
      overflow-y: visible;
      width: 100%;
      padding-bottom: 0px;
      padding-top: 10px;
    }
  }
  .right-section {
    flex: 0 0 auto;
  }
  .tagblock_list > * {
    display: inline-block;
    vertical-align: middle;
  }
  .searchterm.tagblock{
    .tagblock_list{
      padding-top: 0px !important;
    }
  }
}
  .dropdown-menu {
    top: 32px !important;
  }
  .filter-grid {
    padding-left: 0;
    padding-right: 0;
    // border-left: 1px solid #CBD4D8;
    ul {
      list-style: none;
      li {
        //display: inline-block;
      }
      .app-side-menu {
        // background-color: #F2F1F1;
        padding: 14px 0;
        width: 69px;
        text-align: center;
        position: relative;
        top: -2px;
        //background: #F2F1F1;
        cursor: pointer;
      }
      .category {
        // width: 151px;
        // padding: 4px 10px;
        color: #007FEA;
        // padding-left: 10px;
        border-right: 1px solid #E9F1F5;
        border-left: 1px solid #E9F1F5;
        font-size: 1.4rem;
        text-transform: uppercase;
        margin-left: -3px;
        position: relative;
        top: -1px;
        height: 49px;
        .dropdown {
          min-width: 200px;
        }
      }
      .search {
        padding: 0 20px;
        width: 50%;
        svg {
          position: relative;
          top: 0px;
        }
        input {
          outline: none;
          border: 1px solid transparent;
          padding: 0 5px;
          width: 90%;
          font-size: 1.4rem;
        }
      }
    }
    &.filter-button {
      ul {
        @extend %list-unstyled;
        float: right;
        padding: 9.5px 10px;
        li {
          margin: 0 0 0 18px;
          &:last-child {
            margin: 0 0 0 10px;
          }
          .btn-primary {
            @extend %header-primary-btn;
            @extend %bold;
            color: #fff;
            text-transform: uppercase;
          }
          .btn-secondary {
            @extend %header-secondary-btn;
            @extend %bold;
            color: #008AFF;
            text-transform: uppercase;
        }
      }
    }
  }
}
.select_options{
  a{
    text-decoration: none;
  }
}
.action{
  text-decoration: none;
}
.inboundbutton{
      width: 142px !important;
}
.inbounddropdown.el-dropdown-menu.el-popper{
      width: 142px !important;
}
.inbounddropdown .el-dropdown-menu__item{
    margin: 0 0 0 0px !important;
    padding: 5px 10px !important;
}
</style>
